import React, { useState } from 'react';
import { DepositType } from './AddGoalDepositFlow';
import { CURRENCY_SYMBOLS } from './constants';
import { Icon } from '../Icon';
import './DepositAmountInput.css';

interface DepositAmountInputProps {
  value: number;
  onChange: (value: number) => void;
  onNext: () => void;
  onBack: () => void;
  currency?: string;
  depositType?: DepositType;
}

export const DepositAmountInput: React.FC<DepositAmountInputProps> = ({ 
  value, 
  onChange, 
  onNext, 
  onBack, 
  currency = 'RUB',
  depositType
}) => {
  const [display, setDisplay] = useState(value > 0 ? value.toString() : '0');
  const currencySymbol = CURRENCY_SYMBOLS[currency] || currency;

  const handleNumberClick = (num: string) => {
    if (display === '0') {
      setDisplay(num);
    } else if (display.length < 10) {
      setDisplay(display + num);
    }
  };

  const handleDot = () => {
    if (!display.includes('.')) {
      setDisplay(display + '.');
    }
  };

  const handleClear = () => {
    setDisplay('0');
  };

  const handleBackspace = () => {
    if (display.length === 1) {
      setDisplay('0');
    } else {
      setDisplay(display.slice(0, -1));
    }
  };

  const handleSubmit = () => {
    const amount = parseFloat(display);
    if (amount > 0) {
      onChange(amount);
      onNext();
    }
  };

  const quickAmounts = depositType === 'recurring' 
    ? [100, 500, 1000, 2000]
    : [1000, 5000, 10000, 20000];

  const handleQuickAmount = (amount: number) => {
    setDisplay(amount.toString());
  };

  const getTitle = () => {
    if (depositType === 'recurring') {
      return 'Сумма пополнения';
    }
    return 'Сколько пополнить?';
  };

  const getSubtitle = () => {
    if (depositType === 'recurring') {
      return 'Эта сумма будет переводиться регулярно';
    }
    return 'Введите сумму для разового пополнения';
  };

  return (
    <div className="deposit-amount-input step-content">
      <div className="deposit-amount-input__header">
        <button className="deposit-amount-input__back" onClick={onBack}>
          <Icon name="chevron_left" size={20} />
        </button>
        <div className="deposit-amount-input__header-content">
          <h2 className="deposit-amount-input__title">{getTitle()}</h2>
          <p className="deposit-amount-input__subtitle">
            {getSubtitle()}
          </p>
        </div>
      </div>

      <div className="deposit-amount-input__display neo-inset">
        <div className="deposit-amount-input__display-value">{display}</div>
        <div className="deposit-amount-input__display-currency">{currencySymbol}</div>
      </div>

      <div className="deposit-amount-input__quick">
        <div className="deposit-amount-input__quick-title">Быстрый выбор:</div>
        <div className="deposit-amount-input__quick-buttons">
          {quickAmounts.map((amount) => (
            <button
              key={amount}
              className="quick-amount-btn neo-raised"
              onClick={() => handleQuickAmount(amount)}
            >
              {amount.toLocaleString()}
            </button>
          ))}
        </div>
      </div>

      <div className="deposit-amount-input__keypad">
        <div className="keypad-row">
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('1')}>1</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('2')}>2</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('3')}>3</button>
        </div>
        <div className="keypad-row">
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('4')}>4</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('5')}>5</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('6')}>6</button>
        </div>
        <div className="keypad-row">
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('7')}>7</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('8')}>8</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('9')}>9</button>
        </div>
        <div className="keypad-row">
          <button className="keypad-btn neo-raised" onClick={handleDot}>.</button>
          <button className="keypad-btn neo-raised" onClick={() => handleNumberClick('0')}>0</button>
          <button className="keypad-btn neo-raised keypad-btn--action" onClick={handleBackspace}>⌫</button>
        </div>
        <div className="keypad-row">
          <button className="keypad-btn neo-raised keypad-btn--clear" onClick={handleClear}>Очистить</button>
          <button 
            className="keypad-btn neo-raised keypad-btn--submit" 
            onClick={handleSubmit}
            disabled={parseFloat(display) <= 0}
          >
            Далее
          </button>
        </div>
      </div>
    </div>
  );
};

